import { ButtonProtected } from '@components'

import { Color, Drawer, Flex, Icon, Space } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { Scope } from '../../../../../../../../enums/scope'
import { TrackingContext } from '../../../../../../../../enums/trackingContext'
import { useBankTransactionDrawer } from '../../../../contexts'
import { DrawerView } from '../../enums/drawerView'
import { DifferenceSelector } from '../DifferenceSelector'
import { MarkAsPrivateButton } from '../MarkAsPrivateButton'
import { MatchButton } from '../MatchButton'
import { UnmatchButton } from '../UnmatchButton'
import * as Styled from './styles'

interface DrawerFooterProps {
  activeStep: DrawerView
  setActiveStep: (step: DrawerView) => void
  onMatchSuccess: () => void
}

export const DrawerFooter = ({ activeStep, setActiveStep, onMatchSuccess }: DrawerFooterProps): ReactElement => {
  const { t } = useTranslation()
  const {
    hasBankReconciliationWriteScope,
    matchError,
    showDifferenceSelector,
    selectedTransaction,
    combinedTransactions,
    isPrivate,
  } = useBankTransactionDrawer()
  const isMatched = selectedTransaction?.match?.isApproved === true

  const handleTransactionsListFooterClick = () => {
    setActiveStep(DrawerView.Default)
  }

  if (activeStep === DrawerView.AllTransactions) {
    return (
      <Drawer.Footer>
        <ButtonProtected
          disabled={hasBankReconciliationWriteScope && combinedTransactions.size === 0}
          fullWidth
          onClick={handleTransactionsListFooterClick}
          scopes={Scope.BankReconciliationWrite}
          trackingContext={TrackingContext.BankTransactions}
        >
          {t('bank_transactions.drawer.transactions.link_cta')}
        </ButtonProtected>
      </Drawer.Footer>
    )
  }

  return (
    <Drawer.Footer>
      <Flex flexDirection="column" width="100%">
        {matchError && (
          <>
            <Styled.ErrorBox>
              <Styled.ErrorIconWrapper>
                <Icon icon="circleAlert" color={Color.White} />
              </Styled.ErrorIconWrapper>
              {matchError}
            </Styled.ErrorBox>
            <Space size="s16" />
          </>
        )}
        {!matchError && showDifferenceSelector && (
          <>
            <DifferenceSelector />
            <Space size="s16" />
          </>
        )}
        {!isMatched && !isPrivate && <MatchButton onMatchSuccess={onMatchSuccess} />}
        {!isMatched && isPrivate && <MarkAsPrivateButton onSuccess={onMatchSuccess} />}
        {isMatched && <UnmatchButton />}
      </Flex>
    </Drawer.Footer>
  )
}
